export enum UserNotificationsResource {
    NOTIFICATIONS = 'Notifications'
}
